import React from 'react';
import './AccountConfigNotificationPage.css';
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI';
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI';

const AccountConfigNotificationPageUI = ({
  context,
  account,
  whatsappEnabled,
  emailEnabled,
  loading,
  error,
  onToggleWhatsapp,
  onToggleEmail
}) => (
  <SuperUserAccountPageUI
    context={context}
    className='pg_su_acc'
    backLink='/su/accounts'
    headerText={`${account ? account.accountName : ''}`}
    dimension='w768'
    centered={!account}
    account={account}
    page='configNotification'
  >
    <div className="config-notification-container">
      <h2 className="config-notification-title">Config notification</h2>
    {loading ? <SpinnerComponentUI /> :
      <div className="config-notification-card">
        <div className="config-notification-row">
          <span className="config-notification-icon whatsapp">
            <i className="fa fa-whatsapp" />
          </span>
          <span className="config-notification-label">WhatsApp Notification</span>
          <label className="switch">
            <input
              type="checkbox"
              checked={whatsappEnabled}
              disabled={loading}
              onChange={onToggleWhatsapp}
              />
            <span className="slider round"></span>
          </label>
        </div>
        <div className="config-notification-row">
          <span className="config-notification-icon email">
            <i className="fa fa-envelope" />
          </span>
          <span className="config-notification-label">Email Notification</span>
          <label className="switch">
            <input
              type="checkbox"
              checked={emailEnabled}
              disabled={loading}
              onChange={onToggleEmail}
              />
            <span className="slider round"></span>
          </label>
        </div>
        {error && <div className="config-notification-error">{error}</div>}
      </div>
    }
    </div>
  </SuperUserAccountPageUI>
);

export default AccountConfigNotificationPageUI;
